import { z } from 'zod';
import { oneTimeTokenContextGuard, SignInIdentifier, } from '../../foundations/index.js';
import { VerificationType } from './verification-type.js';
export const oneTimeTokenVerificationRecordDataGuard = z.object({
    id: z.string(),
    type: z.literal(VerificationType.OneTimeToken),
    verified: z.boolean(),
    identifier: z.object({
        type: z.literal(SignInIdentifier.Email),
        value: z.string(),
    }),
    oneTimeTokenContext: oneTimeTokenContextGuard.optional(),
});
